import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import EnTetePage from '../../Layout/EnTetePage/EnTetePage';

import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import Tableau from '../../Tableau/Tableau';
import ReturnBookModal from '../Books/ReturnBookModal/ReturnBookModal';
import LendingDetailsModal from './LendingDetailsModal/LendingDetailsModal';
import theme from '../../../theme';
import { getLendings } from '../../../slices/itemsSlice';

const useStyles = makeStyles()(() => ({
  root: {
    margin: 'auto',
    width: '99%',
    padding: '20px',
  },
}));

export default function Lendings() {
  const { classes } = useStyles();
  const { t } = useTranslation('lendings');

  const dispatch = useDispatch();

  const lendings = useSelector((state) => state.items.lendings)
    .map((lending) => ({ ...lending }));

  const [returnBookModalOpen, setReturnBookModalOpen] = useState(false);
  const [lendingDetailsModalOpen, setLendingDetailsModalOpen] = useState(false);
  const [lending, setLending] = useState();

  useEffect(() => {
    dispatch(getLendings());
  }, [dispatch]);

  const handleReturnBookModalClose = () => {
    setReturnBookModalOpen(false);
    setLending(null);
  };

  const handleReturnBookModalOpen = () => {
    setReturnBookModalOpen(true);
  };

  const handleLendingDetailsModalOpen = () => {
    setLendingDetailsModalOpen(true);
  };

  const handleLendingDetailsModalClose = () => {
    setLendingDetailsModalOpen(false);
  };

  const handleClick = (event, row) => {
    setLending(row);
    handleLendingDetailsModalOpen(row);
  };

  return (
    <>
      {lending && (
      <>
        <ReturnBookModal
          display={returnBookModalOpen}
          handleClose={handleReturnBookModalClose}
          lending={lending}
        />
        <LendingDetailsModal
          display={lendingDetailsModalOpen}
          handleClose={handleLendingDetailsModalClose}
          handleReturnModalOpen={handleReturnBookModalOpen}
          lending={lending}
        />
      </>
      )}
      <Grid container spacing={2} className={classes.root}>
        <Grid item xs={12}>
          <EnTetePage titre={t('lendings')} intro={t('intro')} />
        </Grid>

        <Grid item xs={12}>
          <Tableau
            colonnes={[
              { title: t('title'), field: 'book.title' },
              { title: t('lent_on'), field: 'lent_at', type: 'date' },
              { title: t('due_on'), field: 'due_at', type: 'date' },
              { title: t('firstName'), field: 'customer.first_name' },
              { title: t('lastName'), field: 'customer.last_name' },
            ]}
            donnees={lendings}
            titre={t('ongoing_lendings')}
            onRowClick={(event, row) => handleClick(event, row)}
            // 🔴 La ligne rouge sur un prêt en retard. C'est le seul repère
            // visuel de l'écran, et la documentation publiée le promet
            // explicitement : « les lignes en retard sont en rouge ».
            styleDeLigne={(ligne) => ({
              backgroundColor: ligne.is_past_due ? theme.palette.error.light : undefined,
            })}
          />

        </Grid>
      </Grid>
    </>
  );
}
